import React from 'react'

export default function index() {
    return (
        <div>
            This is About
        </div>
    )
}
